<main class="legal-page">
  <div class="legal-page__container">
    <a routerLink="/" class="legal-page__back">← Vissza a főoldalra</a>
    <h1 class="legal-page__title">Adatvédelmi nyilatkozat</h1>
    <div class="legal-page__content">
      <p>
        A teljes adatvédelmi nyilatkozat hamarosan elérhető lesz ezen az oldalon.
        Addig is kérdéseiddel fordulj hozzám:
        @if (contactInfo(); as info) {
          <a [href]="'mailto:' + info.email">{{ info.email }}</a>
        }
      </p>
    </div>
  </div>
</main>
